import React from "react";
import { Carousel, Container, Row, Col } from "react-bootstrap";
import avatar from "../../Assets/avatar.svg";
import Particle from "../Particle";

const testimonials = [
  [
    {
      text:`As a business owner, I have worked with a number of service providers, but the development team behind trolley.com.pk truly stands out in terms of professionalism, expertise, and dedication. From our initial discussion to the successful launch. They translate my ideas into a fully functional website that aligns perfectly with my business objectives. I highly recommend their services to anyone looking for a top-notch professional to work with.`,
      name: "Mirza Mustafa Baig",
      role: "Founder, Trolley Easy Shopping",
    },
    {
      text:`My Brand 3D Premium PK is extremely pleased with the work done by the development team on my 3dpremium.pk website. Youkish Tech demonstrated, provided excellent technical expertise, creativity, and a strong understanding of my business goals. They helped and fulfill our queries in no time and provided the best service ever. And the website is not only visually appealing but also user friendly with smooth navigation and a seamless shopping experience for our customers.`,
      name: "Irfan Ahmed",
      role: "Founder, 3D Premium PK",
    },
  ],
  [
    {
      text:`Thanks to Youkish Tech efforts. JackLeth PK has become a trusted and user friendly online shopping platform. Where I have no hesitation in recommending their services to anyone seeking a reliable, professional, and skilled development team. They have truly made a difference for my business, and Iâ€™m excited to continue working with them in the future.`,
      name: "Ali",
      role: "Founder, JackLeth PK",
    },
    {
      text:`Highly Recommended Yokish Tech. The team is very responsive to my feedback and made sure every detail was implemented to perfection. Thanks to their dedication and professionalism REDCUT Toys has become a robust online platform that I am proud of. I highly recommend their services to anyone looking for top-notch website development.`,
      name: "Shahmeer",
      role: "Founder, REDCUT Toys PK",
    },
  ],
  [
    {
      text:`I was thinking to start an ecommerce business. I am a housewife aswell. And I couldnâ€™t able to find a developer who can get me a professional website at an affordable price. One of my friends Aiman recommended Youkish Tech and im thrilled with the work the development team did on BNM STORE. They took the time to understand the unique needs and my specific Audience. Their ability to grasp my vision and bring it to life exceeded my expectations in every way. Now I understand why my friend recommended and im sure I would love to recommend them with other housewifeâ€™s who wants to start their journey in online ecommerce business.`,
      name: "Bazila",
      role: "Founder, BNM Store PK",
    },
  ],
];

const TestimonialSection = () => {
  return (
    <section className="section-grey testimonial-section" id="testimonial">
      <Particle />
      <Container>
        <Row className="align-items-center">
          <Col md={8}>
            <div className="sections-top-content text-center mb-5">
              <h3 className="project-heading"><span className="purple">TESTIMONIALS</span></h3>
              <p className="text-white mt-4">
                Here's what our valued clients have to say about their experience
                with us. We take pride in delivering exceptional results and
                building lasting relationships.
              </p>
            </div>
          </Col>
          <Col
            md={4}
            className="about-img mb-5">
            <img src={avatar} alt="Portfolio" className="img-fluid" />
          </Col>
        </Row>
        <Carousel className="d-none d-md-block"indicators={true} controls={true}>

        {/* <Carousel className="d-none d-md-block" > */}
          {testimonials.map((group, idx) => (
            <Carousel.Item key={idx}>
              <Row>
                {group.map((item, i) => (
                  <Col className="mt-3" md={6} sm={6} key={i}>
                    <div className="testimonial-comments">
                      <div className="box-text">
                        <p>{item.text}</p>
                      </div>
                      <div className="box-client">
                        <div className="client-info">
                          <h4>{item.name}</h4>
                          <h5>{item.role}</h5>
                        </div>
                      </div>
                    </div>
                  </Col>
                ))}
              </Row>
            </Carousel.Item>
          ))}
        </Carousel>
        <div className="d-md-none">
          {testimonials.map((group, idx) => (
            <div key={idx}>
              <Row>
                {group.map((item, i) => (
                  <Col className="mt-3" md={6} sm={6} key={i}>
                    <div className="testimonial-comments">
                      <div className="box-text">
                        <p>{item.text}</p>
                      </div>
                      <div className="box-client">
                        <div className="client-info">
                          <h4>{item.name}</h4>
                          <h5>{item.role}</h5>
                        </div>
                      </div>
                    </div>
                  </Col>
                ))}
              </Row>
            </div>
          ))}
        </div>
      </Container>
    </section>
  );
};

export default TestimonialSection;
